import type { PropType } from 'vue';

export type ComponentView = 'outlined' | 'border-bottom';

export const defaultComponentView: string = 'border-bottom';

export const componentViewProp = {
    type: String as PropType<ComponentView>,
    default: defaultComponentView,
    required: false,
};
